<template>
  <v-app>
    <div v-if="mode != 'production' && initFinished" class="ribbon">
      <a href="#">{{ mode }}</a>
    </div>

    <BaseLoading
      :isVisible="loading.display && date == null && messageMaintenance == null"
      :message="loading.message"
    />

    <BaseHeader
      v-if="initFinished"
      :isSmartphoneMenu.sync="isSmartphoneMenu"
      :displayMenu.sync="displayMenu"
    />

    <BaseMenu
      v-if="initFinished"
      :isSmartphoneMenu="isSmartphoneMenu"
      :displayMenu.sync="displayMenu"
      :isMini="isMenuMinimal"
    />

    <v-main v-if="initFinished">
      <v-container
        fluid
        v-if="
          (maintenance() &&
            user &&
            (user.roles.includes('ADMIN') ||
              user.roles.includes('SUPERADMIN'))) ||
          !maintenance()
        "
      >
        <router-view transition="fade-transition"></router-view>
      </v-container>
      <v-container grid-list-xs v-else>
        <v-alert
          type="error"
          border="left"
          class="font-weight-black"
          v-if="messageMaintenance"
        >
          <span v-html="messageMaintenance"></span>
        </v-alert>
      </v-container>
    </v-main>
    <BaseSwitchTheme class="switch-theme" />
  </v-app>
</template>

<script>
import BaseLoading from "@/components/base/BaseLoading";
import BaseMenu from "@/components/base/BaseMenu";
import BaseHeader from "@/components/base/BaseHeader";
import BaseSwitchTheme from "@/components/base/BaseSwitchTheme";
import { mapState } from "vuex";
import axios from "axios";
import ApiParametresRepository from "@/repositories/ApiParametresRepository";

export default {
  name: "App",
  components: {
    BaseLoading,
    BaseMenu,
    BaseHeader,
    BaseSwitchTheme,
  },
  data() {
    return {
      displayMenu: null,

      isSmartphoneMenu: this.$isMobile(),

      isMenuMinimal: process.env.VUE_APP_MENU_MINIMAL === "true" ? true : false,

      environnement: process.env.NODE_ENV,
      mode: process.env.VUE_APP_MODE,
      date: null,
      messageMaintenance: null,
    };
  },
  computed: {
    ...mapState(["user", "loading", "isAuthenticated"]),

    initFinished() {
      if (this.isAuthenticated) {
        this.$store.commit("setEcranChargement", false);
        return true;
      }

      if (
        this.$lodash.isEmpty(this.$route.meta) ||
        this.$route.meta.access.type === "authenticated"
      ) {
        return false;
      }

      this.$store.commit("setEcranChargement", false);
      return true;
    },
  },
  watch: {
    "$vuetify.theme.dark"() {
      localStorage.darkTheme = this.$vuetify.theme.dark;
    },
  },
  created: function () {
    var vm = this;
    axios.defaults.timeout = 20000;
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (401 === error.response.status) {
          vm.$store.commit(
            "setMessageEcranChargement",
            "Vous n'êtes plus connecté(e), tentative de reconnexion en cours..."
          );
          vm.$store.commit("setEcranChargement", true);

          setTimeout(
            () =>
              (window.location.href =
                process.env.VUE_APP_BACKEND_API_URL +
                process.env.VUE_APP_URL_LOGIN),
            3000
          );
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
  async mounted() {
    if (localStorage.darkTheme === "true") {
      this.$vuetify.theme.dark = true;
    }
    let parametresMaintenance =
      await ApiParametresRepository.getByNomStartingWithMaintenance();
    this.date = parametresMaintenance["MaintenanceDateFin"];
    this.messageMaintenance = parametresMaintenance["MaintenanceMessage"];
    let dateFormatDate = new Date(Date.parse(this.date.substring(0, 23)));
    let dateFormatString = dateFormatDate.toLocaleDateString("fr-FR", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    let minutes = dateFormatDate.getMinutes();
    this.messageMaintenance = this.messageMaintenance.replace(
      "%MaintenanceDateFin%",
      dateFormatString +
        " à " +
        dateFormatDate.getHours() +
        "h" +
        (minutes < 10 ? "0" + minutes : minutes)
    );
  },
  methods: {
    maintenance() {
      if (this.date) {
        let dateFin = Date.parse(this.date);
        return Date.now() - dateFin > 0 ? false : true;
      }
    },
  },
};
</script>

<style>
html {
  overflow-y: auto;
}

.ribbon {
  background-color: rgba(170, 0, 0, 1);
  left: -3.5em;
  transform: rotate(-45deg);
  overflow: hidden;
  position: fixed;
  top: 30px;
  white-space: nowrap;
  width: 15em;
  z-index: 9999;
  pointer-events: none;
  opacity: 0.75;
  text-align: center;
  padding: 10px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 0.8em;
}

.v-application.theme--light {
  background-color: #ededed !important;
}

.v-application.theme--dark {
  background-color: #121212 !important;
}

.v-application .ribbon a {
  color: #fff;
  text-decoration: none;
}

.title-divider {
  margin: 1rem -1rem;
  max-width: initial;
}

.switch-theme {
  position: absolute !important;
  right: 15px;
  bottom: 15px;
}
</style>
